<div>

    <div class="input-group mb-3" style="display: flex;">
        <!--<div class="input-group-prepend">
      <span class="input-group-text" id="basic-addon1">#</span>
    </div>
    <input type="number" class="form-control" placeholder="Per pagina"
    aria-label="Per pagina" aria-describedby="basic-addon1"
    [(ngModel)]="dom_elements.item_per_page" (change)="refreshCurrentPage()">
    -->

        <div class="btn-group" dropdown style="flex-grow: 1;">
            <button type="button" class="btn btn-outline-primary" (click)="restore()">
                <span class="fa-stack">
                    <i class="fa fa-ban fa-stack-2x"></i>
                    <i class="fa fa-filter fa-stack-1x"></i>
                </span>
            </button>
            <button type="button" class="btn btn-outline-primary" (click)="refreshCurrentPage()">
                <span class="oi oi-reload"></span>
            </button>
            <button id="button-basic" dropdownToggle type="button" class="btn btn-primary dropdown-toggle"
                    aria-controls="dropdown-basic">
                Per pag: {{ travelsHandlerService.travels_list_props.item_per_page }} <span class="caret"></span>
            </button>

            <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu"
                role="menu" aria-labelledby="button-basic">
                <li role="menuitem"><a class="dropdown-item" (click)="itemPerPageChanged(1)">1</a></li>
                <li role="menuitem"><a class="dropdown-item" (click)="itemPerPageChanged(5)">5</a></li>
                <li role="menuitem"><a class="dropdown-item" (click)="itemPerPageChanged(10)">10</a></li>
                <li role="menuitem"><a class="dropdown-item" (click)="itemPerPageChanged(15)">15</a></li>
                <li role="menuitem"><a class="dropdown-item" (click)="itemPerPageChanged(20)">20</a></li>

            </ul>
        </div>

        <pagination [(totalItems)]="travelsHandlerService.travels_list_props.count"
                    [maxSize]="dom_elements.max_size"
                    previousText="&lsaquo;" nextText="&rsaquo;"
                    [(ngModel)]="travelsHandlerService.travels_list_props.current_page"
                    (pageChanged)="pageChanged($event)"
                    [(itemsPerPage)]="travelsHandlerService.travels_list_props.item_per_page">

        </pagination>
    </div>

</div>